import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useSnapshot } from "valtio";
import { viewBookingStore } from "../state/CommonState";
import { AttributeDetails } from "../mui-components/AttributeValueBox";
import Utils from "../util/Utils";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { enquiryStore } from "../enquiry/enquiry-data";
import { CustomPopup } from "../tailwind-components/CustomPopup";
import { DtStore } from "../dt/DtStore";
import { DtMap } from "../dt/DtMap";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY}`,
      color: "black",
      fontSize: 14,
      fontWeight: "bold"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:last-child td, &:last-child th": {
      border: 0,
      borderColor: "#D4D4D4",
    },
  }));


function GetProgress({percentage,actual,total,title="Cargo Delivered"}){
    if(actual && actual > total){
        actual = total;
    }

    return  <Box sx={{display:"flex",flexDirection:"row",gap:2,alignItems:"center"}}>
        <Typography sx={{fontFamily:"Figtree"}}>{title} : <span style={{fontWeight:"bold"}}>{actual} / {total}</span></Typography>
                        <Box sx={{ height: "8px", width: "146px", backgroundColor: "#F5F5F5", borderRadius: "66px" }}>
                        <Box sx={{ height: "100%", width: `${percentage}%`, borderRadius: "66px", backgroundColor: "#2C8A57" }}></Box>
                    </Box>
</Box>
}  


function getPercentage(actual,total){
    if(!actual || !total){
        return 0;
    }

    if(actual>=total){
        return 100;
    }

    let percentage = (actual/total);
    
    return percentage*100;
}

function getActualBundlesCount(vehicleDetails,keyFrom,key="actual_delivery_date"){
    const booking = viewBookingStore.current;
    let actualBundles = 0;
    vehicleDetails.forEach((vehicle)=>{
        if(vehicle[key]?.length>0){
            if(vehicle["number_of_package"]?.length>0){
                actualBundles += parseInt(vehicle["number_of_package"])
            }
        }
    })

    for(let i=1;i<=5;i++){
        let searchFrom = `${keyFrom}${i+1}`
         if(!booking[searchFrom]){
             break;
         }
         booking[searchFrom].forEach((vehicle)=>{
            if(vehicle[key]?.length>0){
                if(vehicle["number_of_package"]?.length>0){
                    actualBundles += parseInt(vehicle["number_of_package"])
                }
            }
        })
    }

    return actualBundles;
}

const dateKeys = ["arrival_factory","cargo_pickup","cargo_arrival_cfs","arrival_dispatch_airport","estimate_delivery_date_to_consignee","actual_delivery_date"];

const originKeyReadableMappers = {
    "origin" : "origin",
    "destination" : "destination",
    "driver_name" : "Driver Name",
    "driver_number" : "Driver Number",
    "vehicle" : "Vehicle Number",
    "arrival_factory" : "Arrival @ Factory",
    "cargo_pickup" : "Cargo Pickup",
    "cargo_arrival_cfs" : "Cargo Arrival at CFS",
    "arrival_dispatch_airport" : "Arrival @ Dispatch Airport",
    "estimate_delivery_date_to_consignee" : "Estimated Delivery Date to consignee",
    "actual_delivery_date" : "Actual Delivery Date",
    "number_of_package" : "Bundles",
    "container_number_vehicle" : "Container Number",
    "loaded_cfs" : "Loaded at CFS",
    "atdfrompod" : "Cargo Picked-up for Delivery",
    "dispatched_from_arrival_airport" : "Dispatched from Arrival Airport",
    "transport_ref_number" : "Transporter Ref Number",
    "transport_name" : "Transporter Name",
    "total_package" : "No. of Packages"
}

function getReadableMapper(key){
    let value = originKeyReadableMappers[key];
    if(value) return value;
    return key
}

function OriginPickUp({vehicles,type}){
    const isFcl = type.includes("FCL");
    const isLcl = type.includes("LCL");
    const isAir = type.includes("Air");
    let isWarehouse = (isLcl || isAir) && vehicles[0]?.["warehouse_1"];
    const theOrginVehicleLength = vehicles?.length;

    let originVehicles = [
        {label :"origin",key:"origin",type:"string"},
        {label :"destination",key:"destination",type:"string"},
        {label :"Driver Name",key:"driver_name",type:"string"},
        {label :"Driver Number",key:"driver_number",type:"string"},
        {label :"Vehicle Number",key:"vehicle",type:"string"},
        {label :"Arrival @ Factory",key:"arrival_factory",type:"date"},
        {label :"Cargo Pickup",key:"cargo_pickup",type:"date"},
    ]

    if(isLcl||isFcl){
        originVehicles.push({label :"Cargo Arrival at CFS",key:"cargo_arrival_cfs",type:"date"})
    }
    
    if(isAir){
        originVehicles.push({label :"Arrival @ Dispatch Airport",key:"arrival_dispatch_airport",type:"date"})
    }

      return <Box sx={{display:"flex",flexDirection:"column",gap:1}}>
      <Typography sx={{fontFamily:'Figtree',fontSize:"16px",color:"#555555",fontWeight:"bold"}}>Origin Pick-up</Typography>
      {vehicles.map((vehicle,i)=>{
         if(isWarehouse){
             originVehicles = [];
             Object.keys(vehicle).forEach((key)=>{
                let isDate = dateKeys.includes(key);
                originVehicles.push({label:getReadableMapper(key),key,type:isDate?"date":"string"})
             })
         }
         return <AttributeDetails details={originVehicles.map((originVehicle)=>({title:originVehicle.label,value:originVehicle.type==="date"?Utils.formatDateBooking(vehicle[originVehicle.key],false):vehicle[originVehicle.key]}))} />
      })}
  </Box>
}

function DestinationPickUp({vehicles,type}){
    const isFcl = type.includes("FCL");
    const isLcl = type.includes("LCL");
    const isAir = type.includes("Air");
    let destinationVehicles = [
        {label :"Vehicle Number",key:"vehicle",type:"string"},
        
        {label :"Estimated Delivery Date to consignee",key:"estimate_delivery_date_to_consignee",type:"date"},
        {label :"Actual Delivery Date",key:"actual_delivery_date",type:"date"},
    ]

    if(isFcl||isLcl){
        destinationVehicles = [
            ...destinationVehicles.slice(0,1),
        {label :"Loaded at CFS",key:"loaded_cfs",type:"date"},
        {label :isFcl? "Dispatched from CFS": "Cargo Picked-up for Delivery",key:"atdfrompod",type:"date"},
        ...destinationVehicles.slice(1)
        ]
    }

    if(isAir){
        destinationVehicles = [
            ...destinationVehicles.slice(0,1),
        {label :"Dispatched from Arrival Airport",key:"dispatched_from_arrival_airport",type:"date"},
        ...destinationVehicles.slice(1)
        ]
    }

    

    return <Box sx={{display:"flex",flexDirection:"column",gap:1}}>
    <Typography sx={{fontFamily:'Figtree',fontSize:"16px",color:"#555555",fontWeight:"bold"}}>Destination Pick-up</Typography>
    {vehicles.map((vehicle)=><AttributeDetails details={destinationVehicles.map((destinationVehicle)=>({title:destinationVehicle.label,value:destinationVehicle.type==="date"?Utils.formatDateBooking(vehicle[destinationVehicle.key],false):vehicle[destinationVehicle.key]}))} />)}
</Box>
}

function TripViewer(){
    let MapUrl = DtStore.MapUrl
    let open = MapUrl && MapUrl.length>0
    return (open) ? <CustomPopup isOpen={open} onClose={()=>{
        DtStore.MapUrl = null
    }}>
        <div className="w-[80vw] h-[80vh]">
        <iframe style={{
                               
                                top: "0",
                                left: "0",
                                bottom: "0",
                                right: "0",
                                width: "100%",
                                height: "100%",
                                border: "none"
                            }} src={MapUrl}></iframe>
        </div>
    </CustomPopup> : <></>
}

// export function VehicleDetailWithoutProgress(){
//     return <Box sx={{display:"flex",flexDirection:"column",gap:1,paddingX:"10px"}}>
//     {booking.vorgin && booking.vorgin.length > 0 && <OriginPickUp vehicles={booking.vorgin} type={booking.shipmentType}/>}
//     {booking.vdes && booking.vdes.length > 0 && <DestinationPickUp vehicles={booking.vdes} type={booking.shipmentType}/>}
// </Box>
// }

export function VehicleDetail(){
    const booking = viewBookingStore.current;
    const final = [];
    if(booking.vorgin && booking.vorgin.length > 0){
        // if( booking.vorgin[0]["number_of_package"]){
         final.push(<ProgressOriginPickup vehicles={booking.vorgin} type={booking.shipmentType} count={booking?.booking?.contract?.cargoTotals?.totNumPackages}/>)
        // }else{
        // final.push(<OriginPickUp vehicles={booking.vorgin} type={booking.shipmentType}/>)
        // }
    }

    if(booking.vdes && booking.vdes.length > 0){
        // if( booking.vdes[0]["number_of_package"]){
         final.push(<ProgressDestination index={0} vehicles={booking.vdes} showProgress={true} type={booking.shipmentType} count={booking?.booking?.contract?.cargoTotals?.totNumPackages}/>)
        // }else{
        // final.push(<DestinationPickUp vehicles={booking.vdes} type={booking.shipmentType}/>)
        // }
    }

    for(let i = 1;i<=5;i++){
        let vdes = `vdes${i+1}`;
        if(!booking[vdes] || booking[vdes].length===0){
            break;
        }
    final.push(<ProgressDestination index={i} vehicles={booking[vdes]} showProgress={true} type={booking.shipmentType} count={booking?.booking?.contract?.cargoTotals?.totNumPackages}/>)
    }

    return  <Box sx={{display:"flex",flexDirection:"column",gap:3,paddingX:"10px"}}>
                  {final.map((comp)=>comp)}
    </Box>  
}

export function ProgressOriginPickup({vehicles,type,booking}){
    const isFcl = type.includes("FCL");
    const isLcl = type.includes("LCL");
    const isAir = type.includes("Air");
    const count = vehicles[0]["total_package"];
    useSnapshot(DtStore);
    let isWarehouse = (isLcl || isAir) && vehicles[0]?.["warehouse_1"];
    const bundlesCount = getActualBundlesCount(vehicles,"vorgin","cargo_pickup");
    const percentage = getPercentage(bundlesCount,parseInt(count))
    let originVehicles = [
        {label :"origin",key:"origin",type:"string"},
        {label :"destination",key:"destination",type:"string"},
        {label :"Driver Name",key:"driver_name",type:"string"},
        {label :"Driver Number",key:"driver_number",type:"string"},
        {label :"Vehicle Number",key:"vehicle",type:"string"},
        {label :"Bundles",key:"number_of_package",type:"string"},
        {label :"Arrival @ Factory",key:"arrival_factory",type:"date"},
        {label :"Cargo Pickup",key:"cargo_pickup",type:"date"},   
    ]

    if(isLcl||isFcl){
        originVehicles.push({label :"Cargo Arrival at CFS",key:"cargo_arrival_cfs",type:"date"})
    }
    
    if(isAir){
        originVehicles.push({label :"Arrival @ Dispatch Airport",key:"arrival_dispatch_airport",type:"date"})
    }

    if(!isWarehouse){
        let anyTripExists = vehicles?.some((vehicle)=>vehicle.tripId?.length>0);
        if(anyTripExists) originVehicles.push({label:"Tracking",onClick:(link)=>{
            DtStore.MapUrl = link;
            DtStore.modalVisible2 = true
         }})
    }

    return <Box sx={{width:"100%",display:"flex",flexDirection:"column",gap:1}}>
        <Box sx={{display:"flex",flexDirection:"row",width:"100%",justifyContent:"space-between"}}>
        <Typography sx={{fontFamily:'Figtree',fontSize:"16px",color:"#555555",fontWeight:"bold"}}>Origin Pick-up Details</Typography>
        <GetProgress percentage={percentage} actual={bundlesCount} total={count} title="Cargo Picked-UP" />
        </Box>
        { isWarehouse ? 
     vehicles.map((vehicle,i)=>{
        if(isWarehouse){
            originVehicles = getPossibleTableValuesForWarehouseOrgin(i,vehicles.length,type,booking);
            // Object.keys(vehicle).forEach((key)=>{
            //     let isDate = dateKeys.includes(key);
            //     originVehicles.push({label:getReadableMapper(key),key,type:isDate?"date":"string"})
            //  })
        }
        if(vehicle.publiclink?.length>0) originVehicles.push({label:"Tracking",component:<a onClick={()=>{
           DtStore.MapUrl = vehicle.publiclink
           DtStore.modalVisible2 = true;
        }}>link</a>})
        return  <TableContainer
        sx={{ border: 1, borderColor: "#D4D4D4", width: "100%", borderRadius: "10px"}}
      >
          <Table sx={{ width: "100%" }}>
                <TableHead>
                    <TableRow>
                    {originVehicles.map((vehicleDetail)=> <StyledTableCell>{vehicleDetail.label}</StyledTableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {originVehicles.map((originDetail)=><StyledTableCell align="right">
                       { originDetail.component ? originDetail.component : <Typography sx={{ display: "flex", fontFamily: "Figtree" }}>{originDetail.type==="date"?Utils.formatDateBooking(vehicle[originDetail.key],false):vehicle[originDetail.key]}</Typography>}
                        </StyledTableCell>)}
                </TableBody>
            </Table>
      </TableContainer> 
     }) : <TableContainer
    sx={{ border: 1, borderColor: "#D4D4D4", width: "100%", borderRadius: "10px"}}
  >
      <Table sx={{ width: "100%" }} aria-label="customized table">
      <TableHead>
          <TableRow>
            {originVehicles.map((vehicleDetail)=> <StyledTableCell>{vehicleDetail.label}</StyledTableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
         {vehicles.map((vehicle)=> {
           return <StyledTableRow >
 {originVehicles.map((originDetail,i)=><StyledTableCell align="right">{ originDetail.onClick ?vehicle.publiclink?.length>0? <a onClick={()=>{
      originDetail.onClick(vehicle.publiclink)
 }} >link</a> : <></> :<Typography sx={{ display: "flex", fontFamily: "Figtree" }}>{originDetail.type==="date"?Utils.formatDateBooking(vehicle[originDetail.key],false):vehicle[originDetail.key]}</Typography>}</StyledTableCell>)}
          </StyledTableRow>
         }
        )}
        </TableBody>
      </Table>
  </TableContainer>
   }
   {/* <TripViewer/>   */}
   <DtMap/>
    </Box>
}

function getPossibleTableValuesForWarehouseOrgin(index,totalVehicleLength,type,booking){
    const isFcl = type.includes("FCL");
    const isLcl = type.includes("LCL");
    const isAir = type.includes("Air");
    const isUsBooking = booking?.pol?.startsWith("US")
    const origin =  {label :"origin",key:"origin",type:"string"}
    const destination = {label :"destination",key:"destination",type:"string"}

    const legTransportKeys = []

    let currentKeyIncludes = [  
        {label :"Driver Name",key:"driver_name",type:"string"},
        {label :"Driver Number",key:"driver_number",type:"string"},
        {label :"Vehicle Number",key:"vehicle",type:"string"},
        {label :"No. of Packages",key:"total_package",type:"string"},
    ];

    if(isUsBooking){
        currentKeyIncludes.unshift(...legTransportKeys);
    }

    const firstLegKeys = [ {label :"Arrival @ Factory",key:"arrival_factory",type:"date"},
        {label :"Cargo Pickup",key:"cargo_pickup",type:"date"},]

    const lastLegKey = [{label:"Cargo Departured for Port",key:"cargo_departed_for_port",type:"date"}]
    const firstWareHouseArrival = {label:"ATA @ Warehouse 1",key:"actual_time_arrival_at_warehouse",type:"date"}

    if(isLcl||isFcl){
        lastLegKey.push({label :"Cargo Arrival at CFS",key:"cargo_arrival_cfs",type:"date"})
    }
    
    if(isAir){
        lastLegKey.push({label :"Arrival @ Dispatch Airport",key:"arrival_dispatch_airport",type:"date"})
    }

    if(totalVehicleLength===1){
        currentKeyIncludes.unshift(origin,destination)
        currentKeyIncludes.push(...firstLegKeys,...lastLegKey)
        return currentKeyIncludes;
    }

    if(index===0){
        currentKeyIncludes.unshift(origin,{label:"Warehouse 1",key:"warehouse_1",type:"string"})
        currentKeyIncludes.push(...firstLegKeys,firstWareHouseArrival);
    }else if(index===totalVehicleLength-1){
        currentKeyIncludes.unshift({label:`Warehouse ${index}`,key:`warehouse_${index}`,type:"string"},destination);
        currentKeyIncludes.push(...lastLegKey)
    }else{
        let warehouses = [];
        warehouses.push({label:`Warehouse ${index}`,key:`warehouse_${index}`,type:"string"})
        warehouses.push({label:`Warehouse ${index+1}`,key:`warehouse_${index+1}`,type:"string"})
        currentKeyIncludes.unshift(...warehouses);
        currentKeyIncludes.push({label:`ATD @ Warehouse ${index}`,key:"actual_time_departed",type:"date"},{label:`ATA @ Warehouse ${index+1}`,key:"actual_time_arrival",type:"date"})
    }

    return currentKeyIncludes;
}

function getPossibleTableValuesForWarehouseDestination(index,totalVehicleLength,type,booking){
    const isFcl = type.includes("FCL");
    const isLcl = type.includes("LCL");
    const isAir = type.includes("Air");
    const isUsBooking = booking?.fpod?.startsWith("US")
    const origin =  {label :"origin",key:"origin",type:"string"}
    const destination = {label :"destination",key:"destination",type:"string"}

    const legTransportKeys = []

    let currentKeyIncludes = [ 
        {label :"Driver Name",key:"driver_name",type:"string"},
        {label :"Driver Number",key:"driver_number",type:"string"},
        {label :"Vehicle Number",key:"vehicle",type:"string"},
        {label :"No. of Packages",key:"total_package",type:"string"},
    ];

    if(isUsBooking){
        currentKeyIncludes.unshift(...legTransportKeys);
    }

    if(isFcl){
        currentKeyIncludes = [
            ...currentKeyIncludes.slice(0,1),
            {label :"Container Number",key:"container_number_vehicle",type:"string"},
            ...currentKeyIncludes.slice(1),
        ]
    }

    let addFirst = [];
    if(isFcl||isLcl){
        addFirst = [
                        {label :"Loaded at CFS",key:"loaded_cfs",type:"date"},
                        {label :isFcl? "Dispatched from CFS": "Cargo Picked-up for Delivery",key:"atdfrompod",type:"date"},
        ]
    }

    if(isAir){
        addFirst.push({label :"Dispatched from Arrival Airport",key:"dispatched_from_arrival_airport",type:"date"})
    }

    const lastLegKey = [ {label :"Estimated Delivery Date to consignee",key:"estimate_delivery_date_to_consignee",type:"date"},
        {label :"Actual Delivery Date",key:"actual_delivery_date",type:"date"},]

    const firstWareHouseArrival = {label:"ATA @ Warehouse 1",key:"actual_time_arrival_at_warehouse",type:"date"}

   console.log(" the lclc llc ll ",(isLcl || isAir) && booking.shipmentScope?.split("-")[2].toLowerCase()==="door" && booking.ltlversion === "Yes")

    

    if(totalVehicleLength===1){
        currentKeyIncludes.unshift(origin,destination)
        currentKeyIncludes.push(...addFirst,...lastLegKey)
        return currentKeyIncludes;
    }

    if(index===0){
        currentKeyIncludes.unshift(origin,{label:"Warehouse 1",key:"warehouse_1",type:"string"})
        currentKeyIncludes.push(...addFirst,firstWareHouseArrival);
    }else if(index===totalVehicleLength-1){
        currentKeyIncludes.unshift({label:`Warehouse ${index}`,key:`warehouse_${index}`,type:"string"},destination);
        if((isLcl || isAir) && booking.shipmentScope?.split("-")[2].toLowerCase()==="door" && booking.ltlversion === "Yes" ){
            currentKeyIncludes.push({label:'Cargo departure from warehouse',key:"cargo_departure_from_warehouse",type:"date"})
        }
        currentKeyIncludes.push(...lastLegKey)
    }else{
        let warehouses = [];
        warehouses.push({label:`Warehouse ${index}`,key:`warehouse_${index}`,type:"string"})
        warehouses.push({label:`Warehouse ${index+1}`,key:`warehouse_${index+1}`,type:"string"})
        currentKeyIncludes.unshift(...warehouses);
        currentKeyIncludes.push({label:`ATD @ Warehouse ${index}`,key:"actual_time_departed",type:"date"},{label:`ATA @ Warehouse ${index+1}`,key:"actual_time_arrival",type:"date"})
    }

    return currentKeyIncludes;
}


export function ProgressDestination({vehicles,type,index,showProgress=false}){
    const isFcl = type.includes("FCL");
    const isLcl = type.includes("LCL");
    const isAir = type.includes("Air");
    let isWarehouse = false;
    if((isLcl || isAir) && vehicles[0]?.["warehouse_1"]!==undefined){
        isWarehouse = true
    }
    console.log(" the weare hosuse ihbbkuhbev iuuhewfvooiefv kjhbefvwoubkjbefw ",isWarehouse)
    const booking = viewBookingStore.current;
    let destinationVehicles = [
        {label :"origin",key:"origin",type:"string"},
        {label :"destination",key:"destination",type:"string"},
        {label :"Driver Name",key:"driver_name",type:"string"},
        {label :"Driver Number",key:"driver_number",type:"string"},
        {label :"Vehicle Number",key:"vehicle",type:"string"},
        {label :"No. of Packages",key:"number_of_package",type:"string"},
        {label :"Estimated Delivery Date to consignee",key:"estimate_delivery_date_to_consignee",type:"date"},
        {label :"Actual Delivery Date",key:"actual_delivery_date",type:"date"},
    ]

    if(isFcl){
        destinationVehicles = [
            ...destinationVehicles.slice(0,1),
            {label :"Container Number",key:"container_number_vehicle",type:"string"},
            ...destinationVehicles.slice(1),
        ]
    }

    if(isFcl||isLcl){
        destinationVehicles = [
            ...destinationVehicles.slice(0,5),
        {label :"Loaded at CFS",key:"loaded_cfs",type:"date"},
        {label :isFcl? "Dispatched from CFS": "Cargo Picked-up for Delivery",key:"atdfrompod",type:"date"},
        ...destinationVehicles.slice(5)
        ]
    }

    if(isAir){
        destinationVehicles = [
            ...destinationVehicles.slice(0,5),
        {label :"Dispatched from Arrival Airport",key:"dispatched_from_arrival_airport",type:"date"},
        ...destinationVehicles.slice(5)
        ]
    }

    if(!isWarehouse){
        let anyTripExists = vehicles?.some((vehicle)=>vehicle.tripId?.length>0);
        if(anyTripExists) destinationVehicles.push({label:"Tracking",onClick:(link)=>{
            DtStore.MapUrl = link;
            DtStore.modalVisible2 = true
         }})
    }

    return <Box sx={{width:"100%",display:"flex",flexDirection:"column",gap:1}}>
   { showProgress && (()=>{
     const count = vehicles[0]["total_package"];
     const bundlesCount = getActualBundlesCount(vehicles,index>0?`vdes${index+1}`:"vdes");
     const percentage = getPercentage(bundlesCount,parseInt(count))
    return <Box sx={{display:"flex",flexDirection:"row",width:"100%",justifyContent:"space-between"}}>
    <Typography sx={{fontFamily:'Figtree',fontSize:"16px",color:"#555555",fontWeight:"bold"}}>Destination Delivery Details</Typography>
    <GetProgress percentage={percentage} actual={bundlesCount} total={count} />
    </Box>})()}
   {booking.vdes2 && <p>Destination {index+1}</p>}
   { isWarehouse ? 
     vehicles.map((vehicle,i)=>{
        if(isWarehouse){
            destinationVehicles = getPossibleTableValuesForWarehouseDestination(i,vehicles.length,type,booking);
            // Object.keys(vehicle).forEach((key)=>{
            //     let isDate = dateKeys.includes(key);
            //     destinationVehicles.push({label:getReadableMapper(key),key,type:isDate?"date":"string"})
            //  })
        }
        if(vehicle.publiclink?.length>0) destinationVehicles.push({label:"Tracking",component:<a onClick={()=>{
            DtStore.MapUrl = vehicle.publiclink
            DtStore.modalVisible2 = true;
         }}>link</a>})
        return  <TableContainer
        sx={{ border: 1, borderColor: "#D4D4D4", width: "100%", borderRadius: "10px"}}
      >
          <Table sx={{ width: "100%" }}>
                <TableHead>
                    <TableRow>
                    {destinationVehicles.map((vehicleDetail)=> <StyledTableCell>{vehicleDetail.label}</StyledTableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {destinationVehicles.map((originDetail)=><StyledTableCell align="right"> { originDetail.component ? originDetail.component : <Typography sx={{ display: "flex", fontFamily: "Figtree" }}>{originDetail.type==="date"?Utils.formatDateBooking(vehicle[originDetail.key],false):vehicle[originDetail.key]}</Typography>}</StyledTableCell>)}
                </TableBody>
            </Table>
      </TableContainer> 
     })
     : <TableContainer
    sx={{ border: 1, borderColor: "#D4D4D4", width: "100%", borderRadius: "10px"}}
  >

      <Table sx={{ width: "100%" }} aria-label="customized table">
      <TableHead>
          <TableRow>
            {destinationVehicles?.filter(item => booking?.transportTypeMultipleDestination[index] === 'DRAYAGE' ? item.key !== "loaded_cfs" : item)?.map((vehicleDetail)=> <StyledTableCell>{vehicleDetail.label}</StyledTableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
         {vehicles.map((vehicle)=> <StyledTableRow >
{destinationVehicles?.filter(item => booking?.transportTypeMultipleDestination[index] === 'DRAYAGE' ? item.key !== "loaded_cfs" : item)?.map((originDetail)=><StyledTableCell align="right">{ originDetail.onClick ?vehicle.publiclink?.length>0? <a onClick={()=>{
      originDetail.onClick(vehicle.publiclink)
 }} >link</a> : <></> :<Typography sx={{ display: "flex", fontFamily: "Figtree" }}>{originDetail.type==="date"?Utils.formatDateBooking(vehicle[originDetail.key],false):vehicle[originDetail.key]}</Typography>}</StyledTableCell>)}
         </StyledTableRow>)}
        </TableBody>
      </Table>
  </TableContainer> 
   }
    
  </Box>
}



export function ProgressVehicleDetail(){
    const booking = viewBookingStore.current;
    return <Box sx={{display:"flex",flexDirection:"column",gap:1,paddingX:"10px"}}>
           {booking.vorgin && booking.vorgin.length > 0 && <ProgressOriginPickup booking={booking} vehicles={booking.vorgin} type={booking.shipmentType}/>}
           {booking.vdes && booking.vdes.length > 0 && <ProgressDestination booking={booking} vehicles={booking.vdes} type={booking.shipmentType}/>}
    </Box>
}


export function VehicleDetailsViewForQuoation(){
    const vehicles = enquiryStore.current.vehicles;
    return <Box sx={{display:"flex",flexDirection:"row",flexWrap:"wrap",justifyContent:"start",width:"100%",paddingX:"10px"}}>
    {vehicles.map((vehicle)=> {
        const vehicleCount = parseInt(vehicle.numVehicles);
        return vehicleCount && vehicleCount>0 ? <Typography sx={{fontFamily:"Figtree",fontSize:"16px",color:"#555555",minWidth:"250px",maxWidth:"250px"}}>{vehicle.numVehicles} x {enquiryStore.current.vehicleDetails.fields[vehicle.vType]}</Typography> : <></>})}
    </Box> 
}